import { createApiClient } from 'lib/api/createApiClient';
import config from 'utils/config';

/** Shared `/v1` exchange API client. Single instance so combos, futures, and
 * other RFQ flows don't each spin up their own. */
export const exchangeApiV1 = createApiClient({ baseURL: `${config.exchangeApiUrl}/v1` });
